export default import.meta.ROLLDOWN_FILE_URL_Cf1M5OLgVbiPnc_xTVv5_Q